import IdentityAPI from './API/IdentityAPI';

export default class IdentityService {
    /**
     * IdentityService constructor.
     * @param {any} options
     * @param {IdentityAPI} identityApi
     */
    constructor(options, identityApi, urlHelper) {
        this.startupOptions = options;

        this.identityApi = identityApi;

        const defaultParticipantId = urlHelper.getParameter('customParticipantId') || urlHelper.getParameter('CustomParticipantID');
        this.customParticipantId = defaultParticipantId;
        this.participantId = defaultParticipantId;
        this.identityKey = defaultParticipantId;
    }

    async authenticate() {
        const { identityProviderId, dataCollectionHash } = this.startupOptions;

        let urlString = window.location.href;
        const sessionGuidKey = 'sessionguid';

        const lowerCaseUrl = urlString.toLowerCase();
         
        if (!new URL(lowerCaseUrl).searchParams.get(sessionGuidKey) && !!window.sessionGuid) {
            urlString += (urlString.includes('?') ? '&' : '?') + `${sessionGuidKey}=${window.sessionGuid}`;
        }

        const result = await this.identityApi.authenticate(identityProviderId, urlString, dataCollectionHash);

        if (result.succeeded) {
            const resultData = result.data.userData;

            this.participantId = resultData.participantId;
            this.identityKey = resultData.identityKey;
        }

        return result;
    }
}